module.exports = __webpack_public_path__ + "static/media/IconTemplates_-04.37e409d1.svg";